module.exports = __webpack_public_path__ + "static/media/plant.40fefb96.png";